import { createAction } from '@reduxjs/toolkit';

export const toggleEndStatus = createAction<boolean>('TOGGLE_END_STATUS');

export const locationChange = createAction('@@router/LOCATION_CHANGE');
